/**
 * Centralized locale utilities for URL generation and management.
 * 
 * This module provides a consistent way to handle locale prefixes in URLs
 * across the application, ensuring clean URLs for default locales.
 */

export { LocaleManager } from './locale-manager';
export {
  markLocaleSwitchNavigation,
  isLocaleSwitchNavigation,
} from './locale-switch-navigation';
export { 
  getLocalizedUrl, 
  getLocalePrefix, 
  shouldIncludeLocaleInUrl,
  type LocalizedUrlOptions, 
} from './get-localized-url';

